"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRolesEffect = exports.handleUnauthorizedAccess = exports.roleRedirectMap = void 0;
var dp_acma_dawn_sdk_1 = require("@greatmindsorg/dp-acma-dawn-sdk");
var react_1 = require("react");
var context_1 = require("../context");
exports.roleRedirectMap = new Map([
    [dp_acma_dawn_sdk_1.CognitoRole.DISTRICT_ADMIN, '/assessments/admin'],
    [dp_acma_dawn_sdk_1.CognitoRole.SCHOOL_ADMIN, '/assessments/admin'],
    [dp_acma_dawn_sdk_1.CognitoRole.TEACHER, '/assessments/teacher'],
]);
/**
 * When calling this function you will be redirected
 * to the home page of the role you belong to
 * @param role
 * @returns
 */
var handleUnauthorizedAccess = function (role) {
    var redirect = exports.roleRedirectMap.get(role);
    if (!redirect)
        return;
    window.location.replace(redirect);
};
exports.handleUnauthorizedAccess = handleUnauthorizedAccess;
var useRolesEffect = function () {
    var _a = (0, react_1.useState)([]), availableRoles = _a[0], setAvailableRoles = _a[1];
    var _b = (0, react_1.useState)(null), activeRole = _b[0], setActiveRole = _b[1];
    var authService = (0, react_1.useContext)(context_1.ServiceContext).authService;
    (0, react_1.useEffect)(function () {
        function fetchRoles() {
            return __awaiter(this, void 0, void 0, function () {
                var roles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, authService.getRoles()];
                        case 1:
                            roles = _a.sent();
                            setAvailableRoles(roles.availableRoles);
                            setActiveRole(roles.activeRole);
                            return [2 /*return*/];
                    }
                });
            });
        }
        fetchRoles();
    }, [authService]);
    var handleRoleChange = (0, react_1.useCallback)(function (role, handleModalClose) {
        function updateRole() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, authService.updateActiveRole(role)];
                        case 1:
                            _a.sent();
                            setActiveRole(role);
                            handleModalClose === null || handleModalClose === void 0 ? void 0 : handleModalClose();
                            (0, exports.handleUnauthorizedAccess)(role);
                            return [2 /*return*/];
                    }
                });
            });
        }
        updateRole();
    }, [authService]);
    return { availableRoles: availableRoles, activeRole: activeRole, handleRoleChange: handleRoleChange };
};
exports.useRolesEffect = useRolesEffect;
